import directives from './directives'

const importDirective = Vue => {
  Vue.directive('numberChineseUnit', directives.numberChineseUnit)
  Vue.directive('clipboard', directives.clipboard)
  Vue.directive('loadmore', directives.loadmore)
  Vue.directive('hasPermi', directives.hasPermi)
}

export default importDirective